import React from 'react';
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ subscriptionActive, children }) {
  if (!subscriptionActive) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
